export default __webpack_public_path__ + "static/media/08.28.24 Minutes of the Meeting of the BOD.9ffc5f21.pdf";